import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async relConferirPreenchimento({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/conferir-preenchimento?codCCustoPai=${filters.codCCustoPai}&codCCustoFilho=${filters.codCCustoFilho}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTrimestral({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/trimestral?codCCustoPai=${filters.codCCustoPai}&codCCustoFilho=${filters.codCCustoFilho}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTrimestralPorRegional({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/trimestral-por-regional?orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relReceita({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/receita?codCCustoPai=${filters.codCCustoPai}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relExportacao({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/exportacao?orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}&tipoRelatorio=${filters.tipoRelatorio}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentario({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/orcamentario?codOrcamentario=${filters.codOrcamentario}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioTrimestral({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/orcamentario-trimestral?codOrcamentario=${filters.codOrcamentario}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioComparativo({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/orcamentario-comparativo?codOrcamentario=${filters.codOrcamentario}&orcamentoId=${filters.orcamentoId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentarioComparativoAno({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/orcamentario-comparativo-ano?codOrcamentario=${filters.codOrcamentario}&orcamentoId=${filters.orcamentoId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relMemoriaCalculo({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/memoria-calculo?codCCustoPai=${filters.codCCustoPai}&codCCustoFilho=${filters.codCCustoFilho}&orcamentoId=${filters.orcamentoId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relOrcamentoTempoReal({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/orcamento-tempo-real?codCCustoPai=${filters.codCCustoPai}&codCCustoFilho=${filters.codCCustoFilho}&orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relTotaisCentroCusto({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/totais-centro-custo?codCCustoPai=${filters.codCCustoPai}&orcamentoId=${filters.orcamentoId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async relImportacaoSistego({ commit }, filters) {
      try {
        const response = await api.get(
          `/relatorios/importacao-sistego?orcamentoId=${filters.orcamentoId}&periodoOrcamento=${filters.periodoOrcamento}`,
        )
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
